import React, { useState } from 'react';
import { Layout } from '../components/Layout/Layout';
import { SearchIcon, FilterIcon, PlusIcon, MapPinIcon, UsersIcon, CalendarIcon } from 'lucide-react';
export const ProjectListingPage = () => {
  const [filterOpen, setFilterOpen] = useState(false);
  // Sample project data - Updated for Malaysia
  const projects = [{
    id: 1,
    title: 'Sustainable Rice Farming Initiative',
    location: 'MADA Region, Kedah',
    image: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1632&q=80',
    description: 'A community-based project focusing on sustainable paddy cultivation using reduced water techniques in the MADA irrigation scheme.',
    funding: 'RM 320,000',
    area: '50 hectares',
    participants: 8,
    timeline: '12 months',
    tags: ['Organic', 'Sustainable', 'Community']
  }, {
    id: 2,
    title: 'Vertical Farming Technology',
    location: 'Cyberjaya, Selangor',
    image: 'https://images.unsplash.com/photo-1505142468610-359e7d316be0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80',
    description: 'Implementing vertical farming technology in urban areas to maximize yield with minimal space in the MSC technology hub.',
    funding: 'RM 550,000',
    area: '500 sq m',
    participants: 4,
    timeline: '18 months',
    tags: ['Technology', 'Urban', 'Innovation']
  }, {
    id: 3,
    title: 'Aquaculture Farming System',
    location: 'Kuala Selangor, Selangor',
    image: 'https://images.unsplash.com/photo-1535090467336-9501f96eef89?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1473&q=80',
    description: 'Implementing sustainable aquaculture techniques to improve fish yield and reduce environmental impact on coastal areas.',
    funding: 'RM 420,000',
    area: '10 hectares',
    participants: 6,
    timeline: '24 months',
    tags: ['Aquaculture', 'Sustainable', 'Coastal']
  }, {
    id: 4,
    title: 'Organic Musang King Durian Farm',
    location: 'Raub, Pahang',
    image: 'https://images.unsplash.com/photo-1622579521530-42bae5f80321?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80',
    description: 'Expanding an established organic durian orchard with premium Musang King varieties for local consumption and export to China.',
    funding: 'RM 490,000',
    area: '20 hectares',
    participants: 5,
    timeline: '36 months',
    tags: ['Organic', 'Fruit', 'Export']
  }];
  return <Layout data-id="element-1397">
      <div className="container mx-auto px-4 py-8" data-id="element-1398">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8" data-id="element-1399">
          <div data-id="element-1400">
            <h1 className="text-3xl font-bold text-soil-brown" data-id="element-1401">My Projects</h1>
            <p className="text-gray-600 mt-1" data-id="element-1402">
              Manage and monitor your agricultural projects
            </p>
          </div>
          <button className="btn btn-primary flex items-center mt-4 md:mt-0" data-id="element-1403">
            <PlusIcon size={18} className="mr-1" data-id="element-1404" />
            Add New Project
          </button>
        </div>
        {/* Search and Filter */}
        <div className="bg-white rounded-lg shadow-sm p-4 mb-8" data-id="element-1405">
          <div className="flex flex-col md:flex-row gap-4" data-id="element-1406">
            <div className="flex-1 relative" data-id="element-1407">
              <SearchIcon size={20} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-1408" />
              <input type="text" placeholder="Search projects..." className="input-field pl-10" data-id="element-1409" />
            </div>
            <button className={`btn ${filterOpen ? 'btn-primary' : 'btn-outline'} flex items-center`} onClick={() => setFilterOpen(!filterOpen)} data-id="element-1410">
              <FilterIcon size={18} className="mr-2" data-id="element-1411" />
              Filter
            </button>
          </div>
          {filterOpen && <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-4 pt-4 border-t" data-id="element-1412">
              <div data-id="element-1413">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-1414">
                  Project Type
                </label>
                <select className="input-field" data-id="element-1415">
                  <option value="" data-id="element-1416">All Types</option>
                  <option value="paddy" data-id="element-1417">Paddy Farming</option>
                  <option value="palm" data-id="element-1418">Palm Oil</option>
                  <option value="durian" data-id="element-1419">Durian</option>
                  <option value="aquaculture" data-id="element-1420">Aquaculture</option>
                  <option value="technology" data-id="element-1421">AgTech</option>
                </select>
              </div>
              <div data-id="element-1422">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-1423">
                  Location
                </label>
                <select className="input-field" data-id="element-1424">
                  <option value="" data-id="element-1425">All Locations</option>
                  <option value="peninsula" data-id="element-1426">Peninsular Malaysia</option>
                  <option value="borneo" data-id="element-1427">Sabah & Sarawak</option>
                  <option value="north" data-id="element-1428">Northern Region</option>
                  <option value="south" data-id="element-1429">Southern Region</option>
                  <option value="east" data-id="element-1430">East Coast</option>
                </select>
              </div>
              <div data-id="element-1431">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-1432">
                  Funding Range
                </label>
                <select className="input-field" data-id="element-1433">
                  <option value="" data-id="element-1434">Any Amount</option>
                  <option value="small" data-id="element-1435">Under RM 200,000</option>
                  <option value="medium" data-id="element-1436">RM 200,000 - RM 500,000</option>
                  <option value="large" data-id="element-1437">Over RM 500,000</option>
                </select>
              </div>
              <div data-id="element-1438">
                <label className="block text-gray-700 font-medium mb-2" data-id="element-1439">
                  Timeline
                </label>
                <select className="input-field" data-id="element-1440">
                  <option value="" data-id="element-1441">Any Duration</option>
                  <option value="short" data-id="element-1442">Under 12 months</option>
                  <option value="medium" data-id="element-1443">12-24 months</option>
                  <option value="long" data-id="element-1444">Over 24 months</option>
                </select>
              </div>
            </div>}
        </div>
        {/* Project List */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1445">
          {projects.map(project => <div key={project.id} className="card overflow-hidden flex flex-col h-full" data-id="element-1446">
              <div className="h-48 overflow-hidden" data-id="element-1447">
                <img src={project.image} alt={project.title} className="w-full h-full object-cover transition-transform hover:scale-105" data-id="element-1448" />
              </div>
              <div className="p-4 flex-grow" data-id="element-1449">
                <h3 className="text-xl font-semibold mb-2" data-id="element-1450">{project.title}</h3>
                <div className="flex items-center text-gray-600 mb-3" data-id="element-1451">
                  <MapPinIcon size={16} className="mr-1" data-id="element-1452" />
                  <span className="text-sm" data-id="element-1453">{project.location}</span>
                </div>
                <p className="text-gray-600 mb-4 line-clamp-3" data-id="element-1454">
                  {project.description}
                </p>
                <div className="grid grid-cols-2 gap-3 mb-4" data-id="element-1455">
                  <div className="bg-leaf-green/10 rounded-md p-2" data-id="element-1456">
                    <p className="text-xs text-gray-600" data-id="element-1457">Funding</p>
                    <p className="font-semibold text-soil-brown" data-id="element-1458">
                      {project.funding}
                    </p>
                  </div>
                  <div className="bg-leaf-green/10 rounded-md p-2" data-id="element-1459">
                    <p className="text-xs text-gray-600" data-id="element-1460">Area</p>
                    <p className="font-semibold text-soil-brown" data-id="element-1461">
                      {project.area}
                    </p>
                  </div>
                  <div className="bg-leaf-green/10 rounded-md p-2 flex flex-col" data-id="element-1462">
                    <p className="text-xs text-gray-600" data-id="element-1463">Team</p>
                    <div className="flex items-center" data-id="element-1464">
                      <UsersIcon size={14} className="mr-1 text-soil-brown" data-id="element-1465" />
                      <p className="font-semibold text-soil-brown" data-id="element-1466">
                        {project.participants}
                      </p>
                    </div>
                  </div>
                  <div className="bg-leaf-green/10 rounded-md p-2 flex flex-col" data-id="element-1467">
                    <p className="text-xs text-gray-600" data-id="element-1468">Timeline</p>
                    <div className="flex items-center" data-id="element-1469">
                      <CalendarIcon size={14} className="mr-1 text-soil-brown" data-id="element-1470" />
                      <p className="font-semibold text-soil-brown" data-id="element-1471">
                        {project.timeline}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="flex flex-wrap gap-2 mt-auto" data-id="element-1472">
                  {project.tags.map((tag, index) => <span key={index} className="bg-wheat-gold/50 text-soil-brown text-xs px-2 py-1 rounded-full" data-id="element-1473">
                      {tag}
                    </span>)}
                </div>
              </div>
              <div className="border-t p-4" data-id="element-1474">
                <button className="btn btn-outline w-full" data-id="element-1475">View Details</button>
              </div>
            </div>)}
        </div>
      </div>
    </Layout>;
};